import React from 'react';

export function ProductSection() {
  return (
    <section id="s-product" className="franchise-section">
      <div className="franchise-section__inner">
        <div className="franchise-product" data-reveal>
          <div className="franchise-product__banner">
            МЕНЮ, КОТОРОЕ <br /> ЗАРАБАТЫВАЕТ
          </div>
          <div className="franchise-product__body">
            <div>
              <div className="franchise-product__body__nums">92</div>
              <div className="franchise-product__body__text">позиции</div>
            </div>
            <div>
              <div className="franchise-product__body__nums">0,8%</div>
              <div className="franchise-product__body__text">минимум <br /> списаний</div>
            </div>
            <div>
              <div className="franchise-product__body__nums">{'>'}48%</div>
              <div className="franchise-product__body__text">заказов <br /> онлайн</div>
            </div>
            <div className="franchise-product__body__nums__last"> высокая <br /> маржинальность</div>
          </div>
          <img className="franchise-product__photo" src="/assets/media/franchise/product-section/photo.jpg" alt="Рыбки" />
          <img className="franchise-product__fish" src="/assets/media/franchise/map-section/fish.svg" alt="Рыбки" />
        </div>
      </div>
    </section>
  );
}
